export const moduleTaskEngine = {
    namespaced: true,
    state: {
        failedJobs: 0
    },
    getters: {
        failedJobs: (state) => state.status
    },
    mutations: {
        setFailedJobs(state, status) {
            state.status = status;
        }
    }
}